"use strict";
/**
 * @fileoverview API response body interface for customer list endpoints
 * Defines the structure for endpoints that return multiple customers with pagination
 */
Object.defineProperty(exports, "__esModule", { value: true });
